<template>
  <component :is="tag" class="player-grid" :style="gridStyle">
    <slot />
  </component>
</template>

<script>
/*
 * Op tablet zo vierkant mogelijk: 4 spelers → 2×2, 7 tot 9 → 3×3. Liggend mag het
 * raster breder zijn dan hoog, staand juist hoger dan breed.
 */
const LANDSCAPE_COLUMNS = { 1: 1, 2: 2, 3: 3, 4: 2, 5: 3, 6: 3, 7: 3, 8: 3, 9: 3 }
const PORTRAIT_COLUMNS = { 1: 1, 2: 2, 3: 1, 4: 2, 5: 2, 6: 2, 7: 2, 8: 2, 9: 3 }

export default {
  name: 'BbPlayerGrid',
  props: {
    count: { type: Number, required: true },
    tag: { type: String, default: 'div' }
  },
  computed: {
    gridStyle() {
      const fallback = Math.ceil(Math.sqrt(this.count))
      return {
        '--cols-landscape': LANDSCAPE_COLUMNS[this.count] ?? fallback,
        '--cols-portrait': PORTRAIT_COLUMNS[this.count] ?? fallback
      }
    }
  }
}
</script>

<style scoped>
.player-grid {
  width: 100%;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

@media (min-width: 600px) {
  .player-grid {
    display: grid;
    grid-template-columns: repeat(var(--cols-portrait), minmax(0, 1fr));
    gap: 1rem;
  }
}

@media (min-width: 600px) and (orientation: landscape) {
  .player-grid {
    grid-template-columns: repeat(var(--cols-landscape), minmax(0, 1fr));
  }
}
</style>
